export default function whatsappButton() {
  const wppFix = document.getElementById("wpp-fix");
  const wppButton = document.getElementById("wpp-link");
  const wppForm = document.getElementById("wpp-form");
  const closeButton = document.getElementById("close-bt");
  const phoneInput = document.getElementById("telefone");
  const mask = document.getElementById("mask");

  if (!wppFix || !wppButton || !wppForm || !closeButton || !phoneInput || !mask) return;

  const output = wppFix.querySelector(".response-output");

  const PHONE_NUMBER = String(wppFix.dataset.wppPhone || "").replace(/\D/g, "");
  if (!PHONE_NUMBER) {
    console.warn("[wpp] data-wpp-phone não definido no #wpp-fix");
    return;
  }

  const DEFAULT_MSG = String(
    wppFix.dataset.wppMsg || "Olá! Vim pelo site e quero um orçamento."
  );

  function openPanel() {
    wppFix.classList.add("open");
    if (output) output.innerHTML = "";
    wppForm.classList.remove("submitting");
  }

  function closePanel() {
    wppFix.classList.remove("open");
  }

  function phoneMask(value) {
    if (!value) return "";
    value = value.replace(/\D/g, "");
    value = value.replace(/(\d{2})(\d)/, "($1) $2");
    value = value.replace(/(\d)(\d{4})$/, "$1-$2");
    return value;
  }

  phoneInput.addEventListener("input", (e) => {
    e.target.value = phoneMask(e.target.value);
  });

  wppButton.addEventListener("click", openPanel);
  closeButton.addEventListener("click", closePanel);
  mask.addEventListener("click", closePanel);

  document.addEventListener("keyup", (e) => {
    if (e.key === "Escape") closePanel();
  });

  function getData(form) {
    const formData = new FormData(form);
    return Object.fromEntries(formData.entries());
  }

  function openWhatsAppNewTab(url) {
    const win = window.open(url, "_blank", "noopener,noreferrer");
    if (win) {
      try { win.focus(); } catch {}
      return true;
    }
    return false;
  }

  function closeThenOpen(url) {
    closePanel();

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const opened = openWhatsAppNewTab(url);

        if (!opened && output) {
          output.style.display = "block";
          output.innerHTML = `
            Seu navegador bloqueou a nova aba.
            <a href="${url}" target="_blank" rel="noopener noreferrer">
              Clique aqui para abrir o WhatsApp
            </a>
          `;
        }
      });
    });
  }

  wppForm.addEventListener("submit", (e) => {
    e.preventDefault();

    const data = getData(wppForm);

    const msg =
      `${DEFAULT_MSG}\n\n` +
      `Nome: ${data.nome}\n` +
      `Telefone: ${data.telefone}\n` +
      `Email: ${data.email}`;

    const url = `https://wa.me/${PHONE_NUMBER}?text=${encodeURIComponent(msg)}`;

    wppForm.classList.add("submitting");

    closeThenOpen(url);
  });
}
